module.exports = __webpack_public_path__ + "static/media/hg_btn.d791ca43.png";